import React from "react";
import styles from "./Mark.module.css";

export interface MarkProps {
  children: React.ReactNode;
}

/**
 * Presentational <mark> wrapper for search-highlighted substrings. Uses a
 * neutral fill (not an accent color) so a match reads as "found" without
 * borrowing semantic meaning from the theme's status colors.
 *
 * Styled via Astryx design tokens, so this MUST be rendered inside an
 * Astryx <Theme> scope.
 */
const Mark = ({ children }: MarkProps): React.ReactElement => {
  return <mark className={styles.mark}>{children}</mark>;
};

export default Mark;
